package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class CompetenceState(
    val id: String,
    competence: String = "",
    niveau: String = ""
) {
    var competence by mutableStateOf(competence)
    var niveau by mutableStateOf(niveau)
}
